import React from 'react'
import { Box, TextModifier, TextV2 as Text, Flex, Colors } from '@pinchenterprisesnpm/friday-ui'
import { useSelector } from 'react-redux'
import { FormikProps, connect } from 'formik'
import { useHistory, useLocation } from 'react-router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/pro-solid-svg-icons'
import { faPen } from '@fortawesome/pro-light-svg-icons'
import { STEP_INDEX } from '@src/features/shift-post-v2/state/shift-post-v2.types'
import { selectSelectedShift } from '@src/data/SelectedShift/selectors'
import { IGigAutoAcceptCertificate } from 'models/GigAutoAcceptCertificate'
import ROUTES from '@src/routing/adminRoutes'
import { SectionContainer } from '../new-edit-modal.style'
import { INewEditModalFormValues } from '../new-edit-modal.form'
import { navigateToEditShift } from '../navigation.utils'

interface IScreeningCriteriaSectionProps {
  formik?: FormikProps<INewEditModalFormValues>
  shiftAutoAcceptCertificates: IGigAutoAcceptCertificate[]
}

const ScreeningCriteriaSection = connect<IScreeningCriteriaSectionProps>(
  ({ formik, shiftAutoAcceptCertificates }) => {
    const history = useHistory()
    const shift = useSelector(selectSelectedShift)
    const { values } = formik
    const location = useLocation()
    const isBusinessShifts = location.pathname.includes(ROUTES.BUSINESSES_LIST)

    const handleNavigateToEditShift = () => {
      navigateToEditShift(
        values,
        shift,
        history,
        STEP_INDEX.SCREENING_REQUIREMENTS,
        isBusinessShifts
      )
    }

    return (
      <SectionContainer>
        <Flex mb='sm' justifyContent='space-between'>
          <Text variant='h6'>Screening Requirements</Text>
          <FontAwesomeIcon
            icon={faPen}
            size='lg'
            style={{
              marginLeft: '8px',
              cursor: 'pointer',
              color: Colors.primary_500,
            }}
            onClick={handleNavigateToEditShift}
          />
        </Flex>

        <Box>
          {shiftAutoAcceptCertificates.map((certObj) => (
            <Flex key={certObj.certificate.id} mb='xs' alignItems='center'>
              <FontAwesomeIcon
                icon={faCheck}
                color='#43b94a'
                size='lg'
                style={{ marginRight: '8px' }}
              />
              <Text>
                Only allow Upshifters with{' '}
                <TextModifier color='primary.500' fontWeight='semiBold'>
                  {certObj.certificate.name}
                </TextModifier>{' '}
                certificate
              </Text>
            </Flex>
          ))}
        </Box>
      </SectionContainer>
    )
  }
)

export default ScreeningCriteriaSection
